import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-target-icon',
  templateUrl: './design-target.component.html'
})
export class DesignTargetComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
